const Profile = () => {
    return (
        <div className="profile">

        </div>
    ) 
}



export default Profile;